var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LinkButton',{attrs:{"to":_vm.toUrl,"title":_vm.$t('general.send_email_to_all_users')}},[_c('b-icon-envelope'),_vm._v("  "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }